import React, { Suspense } from "react";
import { DeploymentRTSPJobsPage } from "./DeploymentRTSPJobTable/DeploymentRTSPJobsPage";

import {
  ContentRoute,
  LayoutSplashScreen
} from "../../../../../../_metronic/layout";
import { Switch } from "react-router-dom";

/**
 * A function component that renders the DeploymentRTSPJobsPage component
 * inside a Suspense component with a fallback of a LayoutSplashScreen.
 *
 * The DeploymentRTSPJobsPage component will be rendered with the setKey
 * property as a prop. The setKey property is used to set the key of the
 * current page in the DeploymentDetails component.
 *
 * @param {function} setKey - a function that sets the key of the current page
 * @returns {ReactElement} - the DeploymentRTSPJobs component
 */
export default function DeploymentRTSPJobs({ setKey }) {
  return (
    <Suspense
      // Show a layout splash screen while the component is being loaded
      fallback={<LayoutSplashScreen />}
    >
      <Switch>
        <ContentRoute
          // Route to the DeploymentRTSPJobsPage component
          path="/admin/deploymentDetails/deploymentRTSPJobsPage"
          children={<DeploymentRTSPJobsPage setKey={setKey} />}
        />
      </Switch>
    </Suspense>
  );
}
